import mitt from "mitt";

type GlobalEvents = {
  ShowLoggedOutModal: void;
  RouterBeforeNavigationStarted: void;
  RouterBeforeNavigationCompleted: void;
};

export const EventBus = mitt<GlobalEvents>();
